import React, { useRef, useState, useEffect } from 'react'
import { Box } from '@mui/system';
import play from 'assets/images/play.svg'

const VideoFrame = ({ fileName, frameSx, videoSx }) => {

    const [playButtonVisibliy, setPlayButtonVisibility] = useState(true)
    const [videoBlobUrl, setVideoBlobUrl] = useState(null)
    const [videoReady, setVideoReady] = useState(false)
    const videoRef = useRef(null)

    const playClickHandler = () => {
        if (videoRef.current) {
            videoRef.current.play().catch(error => {
                console.error('Error playing video:', error);
            });
        }
    }

    // Fetch video as blob to prevent direct URL access
    useEffect(() => {
        if (fileName && !videoBlobUrl) {
            const fetchVideo = async () => {
                try {
                    const response = await fetch(fileName, {
                        method: 'GET',
                        headers: {
                            'Range': 'bytes=0-',
                        },
                        mode: 'cors'
                    });
                    
                    if (response.ok) {
                        const blob = await response.blob();
                        const url = URL.createObjectURL(blob);
                        setVideoBlobUrl(url);
                    }
                } catch (error) {
                    console.error('Error fetching video:', error);
                    // Fallback to direct URL if blob fetch fails
                    setVideoBlobUrl(fileName);
                    setVideoReady(true);
                }
            };
            
            fetchVideo();
        }

        return () => {
            // Cleanup blob URL when component unmounts
            if (videoBlobUrl && videoBlobUrl.startsWith('blob:')) {
                URL.revokeObjectURL(videoBlobUrl);
            }
        };
    }, [fileName, videoBlobUrl]);

    // Enhanced download protection
    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            // Disable right-click context menu
            video.addEventListener('contextmenu', (e) => e.preventDefault());
            
            // Disable drag and drop
            video.addEventListener('dragstart', (e) => e.preventDefault());
            video.addEventListener('drop', (e) => e.preventDefault());
            
            // Disable copy
            video.addEventListener('copy', (e) => e.preventDefault());
            
            // Disable keyboard shortcuts
            video.addEventListener('keydown', (e) => {
                // Disable F12, Ctrl+S, Ctrl+Shift+I, Ctrl+U, etc.
                if (e.key === 'F12' || 
                    e.key === 'F5' ||
                    e.keyCode === 83 && e.ctrlKey ||
                    e.keyCode === 73 && e.ctrlKey && e.shiftKey ||
                    e.keyCode === 85 && e.ctrlKey ||
                    e.keyCode === 80 && e.ctrlKey ||
                    e.keyCode === 83 && e.ctrlKey ||
                    (e.ctrlKey && e.key === 's') ||
                    (e.ctrlKey && e.shiftKey && e.key === 'I') ||
                    (e.ctrlKey && e.key === 'u')) {
                    e.preventDefault();
                    return false;
                }
            });
            
            // Prevent inspect element
            const preventInspect = (e) => {
                if (e.keyCode === 123 || // F12
                    e.keyCode === 73 && e.ctrlKey && e.shiftKey || // Ctrl+Shift+I
                    e.keyCode === 74 && e.ctrlKey && e.shiftKey || // Ctrl+Shift+J
                    e.keyCode === 85 && e.ctrlKey) { // Ctrl+U
                    e.preventDefault();
                    return false;
                }
            };
            
            document.addEventListener('keydown', preventInspect);
            video.addEventListener('loadstart', () => {
                video.removeAttribute('download');
            });

            // Remove video URL from DOM to prevent inspection
            const observer = new MutationObserver(() => {
                video.setAttribute('preload', 'metadata');
            });
            observer.observe(video, { attributes: true });

            return () => {
                document.removeEventListener('keydown', preventInspect);
                observer.disconnect();
            };
        }
    }, []);

    return (
        <Box 
            sx={{
                borderRadius: { xs: 2 },
                overflow: 'hidden',
                display: 'flex',
                background: '#e2e2e2',
                position: 'relative',
                margin: -1,
                WebkitTransform: 'translateZ(0)',
                transform: 'translateZ(0)',
                // Prevent text selection and right-click on the entire frame
                userSelect: 'none',
                WebkitUserSelect: 'none',
                MozUserSelect: 'none',
                msUserSelect: 'none',
                '& *': {
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    MozUserSelect: 'none',
                    msUserSelect: 'none'
                },
                '& video': { videoSx }, ...frameSx
            }}
            onContextMenu={(e) => e.preventDefault()}
            onDragStart={(e) => e.preventDefault()}
            onSelectStart={(e) => e.preventDefault()}
        >
            <Box onClick={playClickHandler} sx={{
                position: 'absolute',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                top: { xs: '60%', lg: '55%' },
                maxWidth: '90px',
                cursor: 'pointer',
                zIndex: 2,
                display: playButtonVisibliy ? 'block' : 'none'
            }}>
                <img style={{ maxWidth: '100%' }} src={play} />
            </Box>
            <video
                playsInline
                onPlay={() => setPlayButtonVisibility(false)}
                onPause={() => setPlayButtonVisibility(true)}
                onLoadedData={() => setVideoReady(true)}
                ref={videoRef}
                controls
                controlsList="nodownload noremoteplayback"
                disablePictureInPicture
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
                onSelectStart={(e) => e.preventDefault()}
                onLoadStart={(e) => {
                    // Additional protection on load
                    e.target.removeAttribute('download');
                }}
                style={{ 
                    position: 'relative', 
                    left: 0, 
                    top: 0, 
                    opacity: 1, 
                    transform: 'translateZ(0)', 
                    WebkitTransform: 'translateZ(0)',
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    MozUserSelect: 'none',
                    msUserSelect: 'none',
                    pointerEvents: 'auto'
                }}
                width="100%">
                <source src={videoBlobUrl || fileName} type="video/mp4" />
            </video>
        </Box>
    );
};

export { VideoFrame };